// extracted by mini-css-extract-plugin
export default {"row":"EvaluationForm_row__QOGiZ","columns11":"EvaluationForm_columns11__Vahod"};